import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { LegacyDevice } from 'console/device/device';
import { Table, TableBody, TableRow } from '@mui/material';
import { Capability } from 'console/device/device-capability';
import { CardTableCell } from '../style/style-card';
import { WiFi } from 'z3k-config';
import * as classnames from 'classnames';
export const WifiCard = memo(function WifiCardImpl(props) {
    const { r_device: device } = props;
    const online = device.online;
    const rssi = device.wifi_state?.rssi;
    const signal = useMemo(() => {
        let signal;
        if (rssi === 0 || rssi == null)
            signal = 0;
        else if (rssi > 90)
            signal = 1;
        else if (rssi > 70)
            signal = 2;
        else if (rssi > 52)
            signal = 3;
        else
            signal = 4;
        return signal;
    }, [rssi]);
    if (!LegacyDevice.has_capability(device?.capabilities, Capability.has_wifi_v2)) {
        return null;
    }
    if (device?.z3k_config?.wifi_settings?.is_enabled !== true) {
        return null;
    }
    return (_jsxs("div", { className: "ui-falarm-main-view-gsm ui-card", children: [_jsx("div", { className: classnames('ui-card-icon ui-icon-zta-gsm-signal', `signal-${signal}`) }), _jsx("h1", { children: "Wi-Fi" }), _jsx(Table, { children: _jsx(TableBody, { children: _jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: "\u0421\u0442\u0430\u0442\u0443\u0441" }), _jsx(CardTableCell, { children: online && WiFi.isConnectedViaWiFi(device.wifi_state)
                                    ? 'Подключен'
                                    : 'Не подключен' })] }) }) })] }));
});
